export const CampaignsStaticMergeFields = {
    '{email}': 'email',
    '{firstname}': 'firstname',
    '{lastname}': 'lastname',
};
